import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { api } from "./api";

// Ensures the user has a stripeCustomerId. Backend /create-customer is idempotent
// by convention — it should return the existing id if one is already linked.
export const ensureStripeCustomer = async ({ user, profile }) => {
  if (!user) throw new Error("signed-in user required");

  if (profile?.stripeCustomerId) return profile.stripeCustomerId;

  // Double-check against the latest doc in case profile in context is stale.
  const snap = await getDoc(doc(db, "users", user.uid));
  const fresh = snap.exists() ? snap.data() : null;
  if (fresh?.stripeCustomerId) return fresh.stripeCustomerId;

  const { data } = await api.post("/create-customer", {
    userId: user.uid,
    email: user.email,
    name: profile?.displayName || user.displayName || user.email,
  });

  const customerId = data?.customerId || data?.id || data?.stripeCustomerId;
  if (!customerId) throw new Error("Backend did not return a customerId");
  return customerId;
};
